import { Component, inject, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { EventViewModel } from '../../../../models-views/event.view.model';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EventResponseModel } from '../../../../models/event.model';
import { BehaviorSubject, combineLatest, Observable, Observer, Subject, takeUntil } from 'rxjs';
import { AppCommon } from '../../../../providers/app-common';
import { formatDate } from '@angular/common';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { NzMessageService } from 'ng-zorro-antd/message';
import { environment } from '../../../../../environments/environment';
@Component({
  selector: 'app-cet-invoices-modal',
  standalone: false,
  templateUrl: './cet-invoices-modal.component.html',
  styleUrl: './cet-invoices-modal.component.scss',

})
export class CetInvoicesModalComponent {
  isEditMode = false;
  eventId:any
  form: FormGroup;
  loggedInUser :any
  loadingConversion:boolean = false
  // Sample dropdown data (replace with actual API/view model data)
  // vendors = [];
  destroy$ = new Subject()
  // quotationRequests = [];
  vendorSubmissions = [];

  // Helper to get display label for a vendor submission id
  // getVendorSubmissionLabel(id: any): string {
  //   if (!id) return '';
  //   // If vendorSubmissions are loaded, try to find by id
  //   const found = this.vendorSubmissions.find((v: any) => v.id === id || v.id == id);
  //   if (found) {
  //     // Try a few paths for the vendor name
  //     const name = found.vendor_details?.name || found.quotation_request_vendor_details?.vendor_details?.name || found.name || '';
  //     return this.formatIdToFourDigits(found.id, 'QR') + (name ? (' - ' + name) : '');
  //   }
  //   // As fallback, if editing and eventData has vendor_submission or vendor name, try that
  //   if (this.eventId?.eventData) {
  //     const ev = this.eventId.eventData;
  //     // If eventData includes nested vendor submission details
  //     if (ev.vendor_submission_details && ev.vendor_submission_details.id == id) {
  //       const name = ev.vendor_submission_details.vendor_details?.name || ev.vendor_submission_details.name || '';
  //       return this.formatIdToFourDigits(ev.vendor_submission_details.id, 'QR') + (name ? (' - ' + name) : '');
  //     }
  //   }
  //   return '';
  // }
  fileList: NzUploadFile[] = []
  loading:boolean = false
  events = [];
  currencyTypes = ['USD', 'EUR', 'INR'];
  currencies = []
  status = [

  // 1. Draft (optional) – before submission or approval
  // 2. Pending Approval (optional) – if invoices require manager or finance review
  // 3. Approved (optional) – confirmed and ready for processing
  // 4. Received – invoice received but not yet paid
  // 5. Partially Paid – payment received partially
  // 6. Fully Paid – payment completed
  // 7. Settled – cleared and reconciled in accounts
  // 8. Overdue – automatically updated based on due date
  // 9. Void / Cancelled – invalidated or cancelled invoice

  {id:'RECEIVED', name :'Received'},
  {id:'PARTIALLY_PAID', name :'Partially Paid'},
  {id:'FULLY_PAID', name :'Fully Paid'},
  {id:'SETTLED', name :'Settled'},
  {id:'OVERDUE', name :'Overdue'},
  {id:'VOID', name :'Void / Cancelled'}

    // {id:'DRAFT',name :'Draft'},
    // {id:'SENT',name :'Sent'},
    // {id:'PAID',name :'Paid'},
    // {id:'PARTIALLY_PAID',name :'Partially Paid'},
    // {id:'OVERDUE',name :'Overdue'},
    // {id:'CANCELLED',name :'Cancelled'},
    // {id:'VOID',name :'Void'}
  ]
  dataMsg:string = 'Creating invoice...'

  constructor(
    private vm: EventViewModel,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private modalRef: NzModalRef,
    private message: NzMessageService
  ) {
      this.eventId = inject(NZ_MODAL_DATA);
      this.vm.cetInvoicesModalComponent = this
      this.initForm()
      if(this.eventId?.eventData){
        this.updateForm()
      }
      this.loggedInUser = AppCommon.getloggedInObject().user
      this.vm.eventResponseModel.subscribe( e => this.events = e.results );
      // this.vm.vendorResponseModel.subscribe( e => this.vendors = e.results );
      this.vm.currencyList.subscribe( e => this.currencies = e.results );
      // this.vm.quotationResponseModel.subscribe( e => this.quotationRequests = e.results );
      this.vm.getEvents(1,5,'cet-invoices-modal')
      this.vm.getUserList(1,500);
      // this.vm.getVendors('', 1,500, 'cet-invoices-modal');
      this.vm.getCurrencyList(1,500)
      // this.vm.getQuotation(1, 100,'cet-invoices-modal')
      const eventId = this.eventId?.eventId || this.eventId?.eventData?.id;

      if (eventId) {
        this.vm.getVendorSubmissions(1, 1000, eventId, '', 'cet-invoices-modal', true);
      }

      this.getCurrencyChange()
      this.getAmountPaidUSD()
      this.setAmountPaidUSD()
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  initForm(){
    this.form = this.fb.group({
      invoice_number: [null, Validators.required],
      issue_date: [null, Validators.required],
      due_date: [null, Validators.required],
      total_amount: [null, Validators.required],
      amount_paid_usd: [{value: null, disabled: true}],
      usd_currency_exchange_rate: [null, Validators.required],
      status: ['RECEIVED',Validators.required],
      description: [null],
      // vendor: [null, Validators.required],
      // quotation_request: [null, Validators.required],
      vendor_submission: [null, Validators.required],
      event: [this.eventId.eventId, Validators.required],
      currency_type: [null, Validators.required],
      file:[[]]
    });
  }

  vendorSubmissionsReceived(e){
    this.vendorSubmissions = e?.results || [];
  }

  updateForm(){
    this.isEditMode = true;
    // console.log("event data  ::",this.eventId.eventData);
    let data = {
      invoice_number:this.eventId.eventData.invoice_number,
      issue_date:this.eventId.eventData.issue_date,
      due_date:this.eventId.eventData.due_date,
      total_amount:this.eventId.eventData.total_amount,
      status:this.eventId.eventData.status,
      description:this.eventId.eventData.description,
      // vendor:this.eventId.eventData.vendor,
      usd_currency_exchange_rate:this.eventId.eventData.usd_currency_exchange_rate,
      amount_paid_usd:this.eventId.eventData.amount_paid_usd,
      // quotation_request:this.eventId.eventData.quotation_request,
      vendor_submission:this.eventId.eventData.vendor_submission,
      event:this.eventId.eventData.event,
      currency_type:this.eventId.eventData.currency_type,
      file:this.eventId.eventData.file
    }
    this.form.patchValue(data)
    this.fileList = this.eventId.eventData.file_details.map(file => ({
        uid: file.id,
        name: this.getFileName(file.file_url),
        status: 'done',
        url: `${environment.api_url}${file.file_url}`
      }))
  }

  handleModalCancel(): void {
    this.loading = false
    this.form.reset();
    this.modalRef.close(true);
  }

  invoiceDetailsupdated(){
    this.handleModalCancel()
  }

  invoiceDetailsUpdateFailed(): void {
    this.loading = false;
  }

getAmountPaidUSD() {
  this.form.get('total_amount').valueChanges.pipe(
    takeUntil(this.destroy$)
  ).subscribe((amount) => {
    const exchangeRate = this.form.get('usd_currency_exchange_rate').value;
    if (amount && exchangeRate) {
      const usdAmount = amount / exchangeRate; // or * if rate is inverted
      this.form.get('amount_paid_usd').setValue(usdAmount.toFixed(2), {emitEvent: false});
    }
  });
}

setAmountPaidUSD() {
  this.form.get('usd_currency_exchange_rate').valueChanges.pipe(
    takeUntil(this.destroy$)
    ).subscribe((exchangeRate) => {
    const amount = this.form.get('total_amount').value;
    if (amount && exchangeRate) {
      const usdAmount = amount / exchangeRate;
      this.form.get('amount_paid_usd').setValue(usdAmount.toFixed(2), {emitEvent: false});
    }
  })
}

  getCurrencyChange(){
      this.form.get('currency_type').valueChanges.subscribe( (e) => {
        this.loadingConversion = true
        this.vm.getconvertedCurrency('2',e,'addinvoice')
      }
    )
  }

  fetchConvertion(){
    // console.log(this.form.get('paid_currency').value)
    if(this.form.get('currency_type').value){
       this.loadingConversion = true
       this.vm.getconvertedCurrency('2',this.form.get('currency_type').value,'addinvoice')
    }
  }

  convertedCurrencyRecieved(e:any){
    // console.log(e)
    if(e.rate){
      this.form.get('usd_currency_exchange_rate').setValue(e.rate.toFixed(2))
      this.loadingConversion = false
    }
  }


   getFileName(file_url:string): string {
    return file_url.split('/').pop()?.split('?')[0] || '';
  }


markAllControlsAsTouched(control: any) {
  if (control instanceof FormGroup || control instanceof FormArray) {
    Object.keys(control.controls).forEach(key => {
      this.markAllControlsAsTouched(control.get(key));
    });
  } else {
    control.markAsTouched();
    control.markAsDirty();
  }
}


  onSubmit(): void {
    if (this.form.valid) {
      // console.log('Form submitted:', this.form.value, this.form.getRawValue());
      let d = this.form.getRawValue()
      d.issue_date = formatDate(new Date(d.issue_date), 'yyyy-MM-dd', 'en-US')
      d.due_date = formatDate(new Date(d.due_date), 'yyyy-MM-dd', 'en-US')

      if(this.eventId?.eventData){
        this.dataMsg = 'Updating invoice...'
        this.loading = true
        d.id = this.eventId.eventData.id;
        d.modified_by = this.loggedInUser.id
        this.vm.updateInvoiceDetails(d)
      } else {
        this.loading = true
        d.created_by = this.loggedInUser.id
        this.vm.createInvoices(d)
      }


      // Perform actual submission logic here
    } else {
      console.warn('Form invalid');
      this.form.markAllAsTouched();
      this.form.markAsDirty
      this.markAllControlsAsTouched(this.form)
      this.message.error('Please fill all required fields correctly');
    }
  }


  downloadFile(event: MouseEvent): void {
    if (this.fileList && this.fileList.length > 0) {
      event.preventDefault();
      event.stopPropagation();
      this.handleDownload(this.fileList[0]);
    }
  }

  // handleDownload = (file: NzUploadFile) => {
  //   let url = file.url;
  //   if (!url && file.response) {
  //     url = file.response.file_url || file.response.file;
  //     if (url && !url.startsWith('http')) {
  //       url = `${environment.api_url}${url}`;
  //     }
  //   }
  //   if (url) {
  //     const link = document.createElement('a');
  //     link.target = '_blank';
  //     link.href = url;
  //     link.download = file.name || 'download';
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   }
  // }


  handleDownload = async (file: NzUploadFile) => {
  let url = file.url;
  if (!url && file.response) {
    url = file.response.file_url || file.response.file;
    if (url && !url.startsWith('http')) {
      url = `${environment.api_url}${url}`;
    }
  }

  if (!url) return;

  try {
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors'
    });
    const blob = await response.blob();
    const downloadUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = file.name || 'download';
    link.click();

    URL.revokeObjectURL(downloadUrl);
  } catch (err) {
    console.error('Download failed:', err);
  }
};


    customUploadRequest = (item: any) => {
     return  this.vm.uploadMediaFile(item, this.loggedInUser.id)
    };

    onUploadChange(event: any): void {
      // console.log('Upload Event:', event);
      if (event.type === 'success') {
        this.form.get('file')?.setValue( [...this.form.get('file').value ,event.file.response.id], { emitEvent: false });
        console.log('File uploaded successfully:', event.file);
      } else if (event.type === 'error') {
        console.error('File upload failed:', event.file);
      } else if(event.type == 'removed'){
        this.fileList = this.fileList.filter(f => f.uid !== event.file.uid);
        this.form.get('file')?.setValue( [...this.fileList ], { emitEvent: false });
        // this.vmt.deleteMediaFile(event.file.uid)
      }


    }

    beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]): Observable<boolean> =>
        new Observable((observer: Observer<boolean>) => {
            const isLt5M = file.size! / 1024 / 1024 < 5;
            if (!isLt5M) {
                this.message.error(`${file.name} is larger than 5MB!`);
                observer.next(false); // Emit false to indicate validation failed
                observer.complete();
            } else {
                observer.next(true); // Emit true to indicate validation passed
                observer.complete();
            }
    });


  formatIdToFourDigits(id: number, str: string): string {
    return id ? str + id.toString().padStart(4, '0') : '';
  }

  getVendorName(id:number): string {
    // const qr = this.quotationRequests.find(q => q.id === id);
    // if (qr) {
    //  console.log(qr)
    // }
    return ""
  }

}
